import html from '../../../assets/svg/html-5.svg';
import css3 from '../../../assets/svg/css3.svg';
import javascript from '../../../assets/svg/javascript.svg';
import reactjs from '../../../assets/svg/reactjs.svg';
import redux from '../../../assets/svg/redux.svg';
import nodejs from '../../../assets/svg/nodejs.svg';
import cpp from '../../../assets/svg/c++.svg';
import python from '../../../assets/svg/python.svg';
import sqldb from '../../../assets/svg/sql-database.svg';
import mongodb from '../../../assets/svg/mongodb.svg';
import sequelize from '../../../assets/svg/sequelize.svg';
import npm from '../../../assets/svg/npm.svg';
import github from '../../../assets/svg/github.svg';
import netlify from '../../../assets/svg/netlify.svg';
import heroku from '../../../assets/svg/heroku.svg';
import postman from '../../../assets/svg/postman.svg';

export const skillItemData = [
    {img: html, name: 'HTML5'},
    {img: css3, name: 'CSS3'},
    {img: javascript, name: 'JAVASCRIPT'},
    {img: reactjs, name: 'REACTJS'},
    {img: redux, name: 'REDUX'},
    {img: nodejs, name: 'NODEJS'},
    {img: cpp, name: 'C++'},
    {img: python, name: 'PYTHON'},
    {img: sqldb, name: 'SQLDB'},
    {img: mongodb, name: 'MONGODB'},
    {img: sequelize, name: 'SEQUELIZE'},
    {img: github, name: 'GITHUB'},
    {img: npm, name: 'NPM'},
    {img: netlify, name: 'NETLIFY'},
    {img: heroku, name: 'HEROKU'},
    {img: postman, name: 'POSTMAN'},
]